export default "__VITE_ASSET__BmG3NQI5__"